function changeSiteLanguage(langID, langCode) {
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";

    for (var i = 0; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    var url = getRequestRoute() + '/p/Home/ChangePageLang';
    var data = 'PID=' + $("#PID").val() + "&PgType=" + $("#PgType").val() + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + langID + ctlgs + "&langCode=" + langCode;

    $.ajax({
        type: 'GET',
        url: url,
        cache: false,
        data: data,
        success: function (dt) {
            window.parent.location.href = dt;
        }
    });

}

function WindowResizeOperation() {
    var isDesktop = true;
    if (isMobileResolution()) {
        isDesktop = false;
    }

    $(window).resize(function () {
        if (isMobileResolution() && isDesktop) {
            location.reload();
        }
        else if (!isMobileResolution() && !isDesktop) {
            location.reload();
        }
    });
}

function backdropControl(event) {
    if (event === "show") {
        $("body").addClass("BackDropped");
        $("body").addClass("no-scroll");
    }
    else {
        $("body").removeClass("BackDropped");
        $("body").removeClass("no-scroll");
    }
}

function NewsletterSetting() {
    $(document).on("click", ".js-newsletter-button", function () {
        $(".js-newsletter-form input[name='email']").val($(".js-newsletter-email").val());
        $(".js-newsletter-modal").modal("show");

        return false;
    });

    $(document).on("submit", ".js-newsletter-form", function () {
        var form = $(this);
        GenerateLocalLoading(form, "show");

        NewsletterAjaxForms(form, function (status, data) {
            if (status == true) {
                $(".js-newsletter-modal").modal("hide");
                $(".js-newsletter-form").trigger("reset");
                $(".js-newsletter-email").val("");

                SwalGenerate("success", data.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
            }
            else {
                SwalGenerate("error", data.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
            
            grecaptchaEvent(form.find("[data-reCaptcha]"), "reset");
            GenerateLocalLoading(form, "hide");
        });

        return false;
    });

    if ($(".js-newsletter-form").length > 0) {
        var emailRequired = $(".js-newsletter-form input[name='email']").attr("data-required");
        var emailValid = $(".js-newsletter-form input[name='email']").attr("data-valid");
        var captchaValid = $(".js-newsletter-form #hiddenRecaptcha").attr("data-message");

        $(".js-newsletter-form").validate({
            ignore: ".ignore",
            rules: {
                "email": {
                    required: true,
                    email: true
                },
                "NewsletterAllowPrivacy": {
                    required: true
                },
                "hiddenRecaptcha": {
                    required: function () { 
                        var captchaId = $(".js-newsletter-form [data-recaptcha]").attr("data-widgetid");
                        
                        if (grecaptcha.getResponse(captchaId) == '') return true;
                        else return false;
                    }
                }
            },
            messages: {
                "email": {
                    required: emailRequired,
                    email: emailValid
                },
                "NewsletterAllowPrivacy": {
                    required: ""
                },
                "hiddenRecaptcha": {
                    required: captchaValid
                }
            }
        });
    }
}

function ContactFormSetting() {
    $(document).on("click", ".js-contact-form-link", function () {
        $(".js-contact-form").trigger("reset");
        $(".js-contact-modal").modal("show")
        return false;
    });

    $(document).on("submit", ".js-contact-form", function () {
        var form = $(this);
        GenerateLocalLoading(form, "show");

        NewsletterAjaxForms(form, function (status, data) {
            if (status == true) {
                $(".js-contact-modal").modal("hide");
                $(".js-contact-form").trigger("reset");

                SwalGenerate("success", data.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
            }
            else {
                SwalGenerate("error", data.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }

            grecaptchaEvent(form.find("[data-reCaptcha]"), "reset");
            GenerateLocalLoading(form, "hide");
        });

        return false;
    });

    if ($(".js-contact-form").length > 0) {
        $(".js-contact-form").validate({
            ignore: ".ignore",
            rules: {
                "name": {
                    required: true
                },
                "email": {
                    required: true,
                    email: true
                },
                "subject": {
                    required: true
                },
                "message": {
                    required: true
                },
                "hiddenContactRecaptcha": {
                    required: function () {
                        var captchaId = $(".js-contact-form [data-recaptcha]").attr("data-widgetid");

                        if (grecaptcha.getResponse(captchaId) == '') return true;
                        else return false;
                    }
                }
            },
            messages: {
                "name": {
                    required: $(".js-contact-form input[name='name']").attr("data-required"),
                },
                "email": {
                    required: $(".js-contact-form input[name='email']").attr("data-required"),
                    email: $(".js-contact-form input[name='email']").attr("data-valid")
                },
                "subject": {
                    required: $(".js-contact-form input[name='subject']").attr("data-required"),
                },
                "message": {
                    required: $(".js-contact-form textarea[name='message']").attr("data-required"),
                },
                "hiddenContactRecaptcha": {
                    required: $(".js-contact-form #hiddenContactRecaptcha").attr("data-message")
                }
            }
        });
    }
}

function recaptchaCallback() {
    if ($("[data-reCaptcha]:not([data-widgetid])").length > 0) {
        $("[data-reCaptcha]:not([data-widgetid])").each(function () {
            grecaptchaEvent($(this), "render");
        });
    }
}

$(document).ready(function () {
    WindowResizeOperation();
    NewsletterSetting();
    ContactFormSetting();
    CheckUserLoginForUserInfoObj();

    if ($(".js-user-navigation").length > 0) {
        GetSepetIcerik(false);
    }

    $(document).on("click", "body.BackDropped .backdrop", function () {
        $("body").removeClass("BackDropped");
        $("body").removeClass("no-scroll");
        hideBasket();
        MobileFilterOperation("hide");
        $(".js-icon-burger").removeClass("active");
        $(".js-menu-navigation").css("height", "0");
    });

    $(document).on("click", ".js-lang-selector-item", function () {
        var id = $(this).attr('data-value');
        var code = $(this).attr('data-code');

        changeSiteLanguage(id, code);
    });

    $(document).on("click", ".errorContainer .SearchArea .input-group-append", function () {
        $(".SearchArea form").trigger("submit");
    });

    $(document).on("click", ".js-mini-cart-delete", function () {
        var ItemID = $(this).attr("data-id");
        var LangID = $("#LangID").val();
        var element = $(this).closest(".js-product-item");

        GenerateLocalLoading(element, "show");

        RemoveFromCart(ItemID, LangID, function (status, dt) {
            GenerateLocalLoading(element, "hide");
            element.remove();

            if (status) {
                GetSepetIcerik(true);
            }
            else {
                SwalGenerate("error", dt, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        });
    });

    var utm_source = getQuery(window.location.href).utm_source;
    var utm_campaign = getQuery(window.location.href).utm_campaign;
    var utm_medium = getQuery(window.location.href).utm_medium;

    if ((utm_source != undefined && utm_source.length > 0) || (utm_campaign != undefined && utm_campaign.length > 0) || (utm_medium != undefined && utm_medium.length > 0)) {
        $.ajax({
            url: "/" + $("#SmallLangCode").val() + "/p/User/SetUtmParam",
            data: "utm_source=" + utm_source + "&utm_campaign=" + utm_campaign + "&utm_medium=" + utm_medium,
            type: "POST",
            cache: false
        });
    }

    if (isMobileResolution) {
        setTimeout(function () {

            try {
                var touch = document.createEvent("Event");
                touch.initEvent("touchstart", true, true);
                document.body.dispatchEvent(touch);
            } catch (e) { }

        }, 50);
    }
});